import { render, staticRenderFns } from "./DomainOppositionBasisForOppositionForm.vue?vue&type=template&id=66d24434&"
import script from "./DomainOppositionBasisForOppositionForm.vue?vue&type=script&lang=js&"
export * from "./DomainOppositionBasisForOppositionForm.vue?vue&type=script&lang=js&"
import style0 from "./DomainOppositionBasisForOppositionForm.vue?vue&type=style&index=0&id=66d24434&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports